import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_order_linesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { order_id: number }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, OrderLineTypeId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, ProcessInSinglePickSlip?: boolean, StatusId?: number, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, HoursAllowedInAmbient?: number, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number, Warehouse?: { Name?: string } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_order_lines/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { order_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, OrderLineTypeId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, ProcessInSinglePickSlip?: boolean, StatusId?: number, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, HoursAllowedInAmbient?: number, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number, Warehouse?: { Name?: string } }[] } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_order_lines/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { order_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, OrderLineTypeId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, ProcessInSinglePickSlip?: boolean, StatusId?: number, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, HoursAllowedInAmbient?: number, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number, Warehouse?: { Name?: string } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_order_lines/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      order_id: number    }) {
        if(isNil(inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
